export default "__VITE_ASSET__e516e94d__"